/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowLeftFromBracket: {
  name: 'arrow-left-from-bracket';
  data: string;
} = {
  name: 'arrow-left-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 .5a.5.5 0 0 0 0 1h1a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-1a.5.5 0 0 0 0 1h1a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5h-1ZM4.4 4.3a.5.5 0 0 0-.8-.6l-3 4a.5.5 0 0 0 0 .6l3 4a.5.5 0 0 0 .8-.6L2 8.5h9a.5.5 0 0 0 0-1H2l2.4-3.2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
